/** @format */

import { useEffect, useState } from "react";

export const InternalNav = ({ active, setActive, from, display }) => {
  const [navData, setNavData] = useState([]);

  useEffect(() => {
    if (from === "service-stats") setNavData(serviceStats);
    if (from === "history") setNavData(history);
    if (from === "guarantor") setNavData(guarantor);
    if (from === "driver") setNavData(driver);
    if (from === "manger") setNavData(manger);
  }, [from]);
  return (
    <ul
      className='internal-nav'
      style={display ? { flexDirection: display } : {}}>
      {navData.map((item, key) => (
        <li
          key={key}
          onClick={() => setActive(item.active)}
          className={`internal-nav__item ${
            active === item.active ? "item--active" : ""
          }`}>
          {item.name}
        </li>
      ))}
    </ul>
  );
};

const guarantor = [
  {
    name: "سجل الطلبات",
    active: "history",
  },
  { name: " البيانات الشخصية", active: "data" },
  { name: " الاوراق الشخصية", active: "papers" },
];
const history = [
  {
    name: "الكــــل ",
    active: "all",
  },
  { name: " الطلبات تمت", active: "success" },
  { name: " الطلبات قيدالانتظار", active: "wait" },
  { name: " الطلبات الملغيه  ", active: "faild" },
];

const driver = [
  {
    name: "  الطلبات الاخيره",
    active: "last-orders",
  },
  {
    name: "الطلبات",
    active: "orders",
  },
  {
    name: "البيانات الشخصية    ",
    active: "personal-info",
  },
];
const manger = [
  {
    name: "  الانشطة الاخيرة ",
    active: "last-activity",
  },

  {
    name: "البيانات الشخصية    ",
    active: "personal-info",
  },
];
const serviceStats = [
  {
    name: "يوميا ",
    active: "today",
  },
  {
    name: "اسبوعيا ",
    active: "week",
  },
  {
    name: "شهريا ",
    active: "month",
  },
  
];
